module.exports = "<svg fill=\"currentColor\" viewBox=\"0 0 40 40\"><path d=\"m16.6 10 10 10-10 10-2.3-2.3L22 20l-7.7-7.7z\"></path></svg>"